import {
  GetTpList,
  getTpList,
  deleteList,
  DeleteList,
  GetDetailList,
  getDetailList,
  GetDetailStd,
  getDetailStd,
  getAreaData,
  getKillChain,
  getRingPattern,
  getResultRiskLevel,
  getDefenseRankings,
  getDeviceAlarmStat,
  getPluginLog,
  stopTask,
  retestTask,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  getAttackPathData,
  getTaskList,
  getTaskExecList,
  getGroupList,
  deleteTask,
  getTaskDetail,
  getAttackPathList,
  getTaskBaseInfo,
  getSecurityDeviceList,
  getTaskDetailTemplateList,
  getTaskDetailCaseList,
  getTaskDetailCaseAttackType,
} from '@/api/threat-list-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'

export const useGetTpList = () => {
  const { runAsync: run, data } = useRequest((params: GetTpList) => getTpList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务列表失败')
    },
  })

  return [run] as const
}

// 获取杀伤链列表
export const useGetKillChain = () => {
  const { data, runAsync: run } = useRequest(params => getKillChain(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取杀伤链失败')
    },
  })

  return [data?.data?.kill_rate || [], run] as const
}
// 获取任务摘要、任务拦截
export const useGetRingPattern = () => {
  const { data, runAsync: run } = useRequest(params => getRingPattern(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务摘要、任务拦截失败')
    },
  })

  return [data?.data?.kill_rate || [], run] as const
}
// 获取危险等级分布
export const useGetResultRiskLevel = () => {
  const { data, runAsync: run } = useRequest(params => getResultRiskLevel(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取危险等级分布失败')
    },
  })

  return [data?.data || [], run] as const
}
// 攻击防护排名
export const useGetDefenseRankings = () => {
  const { data, runAsync: run } = useRequest(params => getDefenseRankings(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取攻击防护排名失败')
    },
  })

  return [data?.data?.attack_rate || [], run] as const
}
// 获取设备告警统计
export const useGetDeviceAlarmStat = () => {
  const { data, runAsync: run } = useRequest(params => getDeviceAlarmStat(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取设备告警统计失败')
    },
  })

  return [data?.data?.items || [], run] as const
}
// 获取告警日志
export const useGetPluginLog = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest(params => getPluginLog(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取告警日志失败')
    },
  })

  return [data?.data?.items || [], run, loading] as const
}
export const useGetAreaData = () => {
  const { data, runAsync: run } = useRequest(() => getAreaData(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全域失败')
    },
  })

  return [data?.data?.items || [], run] as const
}
// 删除子任务
export const useDeleteTaskExec = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteList) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除子任务失败')
    },
  })

  return [run, loading] as const
}
// 查看详情列表
export const useGetDetailList = () => {
  const { runAsync: run } = useRequest((data: GetDetailList) => getDetailList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取详情列表失败')
    },
  })
  return [run] as const
}
// 详情基础数据
export const useGetDetailStd = () => {
  const { data, runAsync: run } = useRequest((datas: GetDetailStd) => getDetailStd(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取详情基础数据失败')
    },
  })
  return [data?.data || [], run] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取详情列表失败')
    },
  })
  return [run] as const
}

// 任务复测
export const useReTestTask = () => {
  const { runAsync: run, loading } = useRequest(data => retestTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '任务复测失败')
    },
  })

  return [run, loading] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取例状态列表失败')
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取例状态列表失败')
    },
  })
  return [run] as const
}

// 获取攻击路径
export const useGetAttackPathData = () => {
  const { data, runAsync: run } = useRequest(() => getAttackPathData(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取攻击路径失败')
    },
  })

  return [data?.data?.list || [], run] as const
}

// 获取主任务列表
export const useGetTaskList = () => {
  const { runAsync: run, loading } = useRequest(data => getTaskList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取主任务列表失败')
    },
  })

  return [run, loading] as const
}

// 获取任务执行列表
export const useGetTaskExecList = () => {
  const { runAsync: run, loading } = useRequest(data => getTaskExecList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务执行列表失败')
    },
  })

  return [run, loading] as const
}

// 获取分组列表 (筛选)
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest(() => getGroupList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取分组列表失败')
    },
  })

  return [run, data?.data?.list || []] as const
}

// 删除主任务
export const useDeleteTask = () => {
  const { runAsync: run, loading } = useRequest((id: string[]) => deleteTask(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除主任务失败')
    },
  })

  return [run, loading] as const
}

// 获取主任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskDetail(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务详情失败')
    },
  })

  return [run] as const
}

// 获取攻击路径列表 (筛选)
export const useGetAttackPathList = () => {
  const { runAsync: run, data } = useRequest(() => getAttackPathList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取攻击路径列表失败')
    },
  })

  return [run, data?.data?.list || []] as const
}

// 获取任务基础信息
export const useGetTaskBaseInfo = () => {
  const { runAsync: run, data } = useRequest((id: string) => getTaskBaseInfo(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务基础信息失败')
    },
  })

  return [run, data?.data || []] as const
}

// 任务详情关联模板列表
export const useGetTaskDetailTemplateList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联模板列表失败')
    },
  })

  return [run, loading] as const
}

// 任务详情关联模板获取用例列表
export const useGetTaskDetailCaseList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联模板用例列表失败')
    },
  })

  return [run, loading] as const
}

// 关联模板用例的攻击类型筛选
export const useGetTaskDetailCaseAttackType = () => {
  const { data, runAsync: run } = useRequest(params => getTaskDetailCaseAttackType(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取关联模板用例攻击类型失败')
    },
  })

  return [data?.data?.attackTypeFilters || [], run] as const
}

// 获取安全设备列表 (筛选)
export const useGetSecurityDeviceList = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityDeviceList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全设备列表失败')
    },
  })

  return [run, data?.data?.list || []] as const
}
